import React from 'react'
import "../styles/About.css"

const About = () => {
    return (
        <>
            <section className="about-wrapper">
                <div className="home-text">
                    <h1 className="fs">Cultivating Excellence <br /> One - Blade a time</h1>
                    <p className="fs1">Discover the passion, expertise, and dedication behind</p>
                    <button className="homebtn">See our story</button>
                </div>
            </section>
            <section className='abtparent'>
                <div className='abtmain'>
                    <h1>Our Journey: From Humble Beginnings to Industry Leaders</h1>
                    <div className='subabt'>
                        <div className='subabt1'>
                            <h2>Lorem Ipsum</h2>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. </p>
                        </div>
                        <img className='subabt2' src="/assets/about/abtgroup.png" alt="" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default About